import React, { SetStateAction } from 'react'
import classes from './AttributeForm.module.sass'
import { Item } from './components/item/Item'
import { useForm } from './hooks/useForm'
import { Button } from '../button/Button'
import { v4 } from 'uuid'
import { CategoryAttribute } from '../../types/interfaces'

type Props<T> = {
  topData: T & { attributes: CategoryAttribute[] }
  setTopData: (data: T & { attributes: CategoryAttribute[] }) => void
  setDisabled: React.Dispatch<SetStateAction<boolean>>
  disabled: boolean
}

export const AttributeForm = <T,>({ topData, setTopData, setDisabled, disabled }: Props<T>) => {
  const { data, addItem, removeItem, itemUp, itemDown, handleAttributeChange, itemPattern } =
    useForm(
      topData,
      setTopData as React.Dispatch<React.SetStateAction<typeof topData>>,
      setDisabled,
    )

  return (
    <div className={classes.container}>
      {!data.length && (
        <div className={classes.button}>
          <Button
            small
            text="Добавить"
            onClick={() => {
              addItem({ ...itemPattern, id: v4(), externalId: v4() })
            }}
          />
        </div>
      )}
      {data.map((el, index) => (
        <Item
          index={index}
          key={el.id}
          onChange={handleAttributeChange}
          el={el}
          length={data.length}
          addItem={addItem}
          removeItem={removeItem}
          itemUp={itemUp}
          itemDown={itemDown}
        />
      ))}
    </div>
  )
}
